class OrderEmailsController {

    constructor(ordersApiService, messageService) {
        this.ordersApiService = ordersApiService;
        this.messageService = messageService;
    }

    emailButtonDisabled () {
        return this.saving || [10, 4, 3].indexOf(this.order.order_status_id) === -1;
    }

    sendEmail (sendTo = 'customer') {
        this.saving = true;

        let message = this.determineEmailMessage(sendTo);

        return this.ordersApiService.sendEmail(this.order.id, sendTo)
            .then(() => {
                this.messageService.success(message);
            })
            .catch(() => {
                this.messageService.failure(`There was an error sending the ${sendTo} email`);
            })
            .then(() => {
                this.messageService.push();
                this.saving = false;
            });
    }

    determineEmailMessage (sendTo) {
        let destination = '';
        let type = '';

        switch (sendTo) {
            case 'customer':
                type = ' customer';
                destination = this.order.customer.email;
                break;
            case 'admin':
                type = 'n admin';
                destination = 'your property';
                break;
            case 'invoice':
                type = ' customer invoice';
                destination = this.order.customer.email;
                break;
        }

        return `A${type} email has been sent to ${destination}.`;
    }
}

OrderEmailsController.$inject = ['ordersApiService', 'messageService'];

export default OrderEmailsController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/order/controllers/order.emails.controller.js